import { capped, type FriseClues as Clues } from "../lib/dayFrise";
import { hm } from "./TimelineWeekBoard";

/** Indices d'un temps sans projet, à plat : heures et voisins, puis ce que le
 * kit a vu. `skipTitle` évite de redire le titre qui nomme déjà le groupe. */
export function FriseClues({
  clues,
  skipTitle,
}: {
  clues: Clues;
  skipTitle?: string;
}) {
  const slots = clues.slots.map((s) => `${hm(s.startMin)}-${hm(s.endMin)}`);
  const titles = clues.titles
    .filter((t) => t !== skipTitle)
    .map((t) => `« ${t} »`);
  const when = [
    ...(slots.length ? [capped(slots)] : []),
    ...(clues.before.length ? [`avant : ${capped(clues.before)}`] : []),
    ...(clues.after.length ? [`après : ${capped(clues.after)}`] : []),
  ];
  const seen = [
    ...(titles.length ? [capped(titles)] : []),
    ...(clues.roots.length ? [`dossiers : ${capped(clues.roots)}`] : []),
    ...(clues.sshHosts.length ? [`ssh : ${capped(clues.sshHosts)}`] : []),
    ...(clues.tools.length ? [`outils : ${capped(clues.tools)}`] : []),
  ];
  return (
    <>
      {when.length > 0 && <span className="wb-gclue">{when.join(" · ")}</span>}
      {seen.length > 0 && <span className="wb-gclue">{seen.join(" · ")}</span>}
    </>
  );
}
